// Packages
import { combineReducers } from 'redux';

// Internal
import formList from './FormList/reducer';
import formEditor from './FormEditor/reducer';
import formClient from './FormClient/reducer';
import notificator from '../common/notificator/reducer';
import workastData from './WorkastData/reducer';

export default combineReducers({
  formList,
  formEditor,
  formClient,
  notificator,
  workastData
});
